export function callbackFollowFavoriteStore(context, filialId) {
    const htmlCallback = `
    <callback-app callback="followFavoriteStore">
        <callback-param key="storeId" value="${filialId}"></callback-param>
    </callback-app>`;
    context.insertAdjacentHTML('beforeend', htmlCallback);
}

export function callbackSetTemporaryStore(context, filialId) {
  const htmlCallback = `
    <callback-app callback="setTemporaryStore">
        <callback-param key="storeId" value="${filialId}"></callback-param>
    </callback-app>`;
  context.insertAdjacentHTML('beforeend', htmlCallback);
}

export function callbackCloseWebview(context) {
  const htmlCallback = `
    <callback-app callback="closeWebview">
    </callback-app>`;
  context.insertAdjacentHTML('beforeend', htmlCallback);
}

export function callbackSetTitle(context, title) {
  const htmlCallback = `
    <callback-app callback="setTitle">
        <callback-param key="title" value="${title}"></callback-param>    
    </callback-app>`;
  context.insertAdjacentHTML('beforeend', htmlCallback);
}
